import { useState } from 'react';
import type { AccountUserRoleUser, FetchUsersByRoleResponse } from 'vopay';
import { api } from '@/services/api.config';

/**
 * Direct Pattern hook for fetching the users assigned to a specific Role.
 * Hits GET /account/user-roles/role?RoleID=<n>.
 */
export default function useFetchUsersByRole() {
  const [fetching, setFetching] = useState(false);
  const [users, setUsers] = useState<AccountUserRoleUser[]>([]);

  async function fetchUsersByRole(roleId: number, bearer?: string): Promise<FetchUsersByRoleResponse> {
    try {
      setFetching(true);
      const res = await api.fetchUsersByRole({ RoleID: roleId }, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setUsers(res.Users);

      return res;
    } catch (error) {
      console.error('Fetch users by role failed:', error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  function reset() {
    setUsers([]);
  }

  return { fetching, users, fetchUsersByRole, reset };
}
